module.exports = __webpack_public_path__ + "img/logo16.b4741b01.png";